import api from './api';

export const leadService = {
  // Get all leads
  getLeads: async (params = {}) => {
    const response = await api.get('/v1/leads/', { params });
    return response.data;
  },

  // Get single lead
  getLead: async (id) => {
    const response = await api.get(`/v1/leads/${id}/`);
    return response.data;
  },

  // Create new lead
  createLead: async (leadData) => {
    const response = await api.post('/v1/leads/', leadData);
    return response.data;
  },

  // Update lead
  updateLead: async (id, leadData) => {
    const response = await api.put(`/v1/leads/${id}/`, leadData);
    return response.data;
  },

  // Partially update lead
  patchLead: async (id, leadData) => {
    const response = await api.patch(`/v1/leads/${id}/`, leadData);
    return response.data;
  },

  // Delete lead
  deleteLead: async (id) => {
    const response = await api.delete(`/v1/leads/${id}/`);
    return response.data;
  },

  // Get lead activities
  getLeadActivities: async (leadId) => {
    const response = await api.get(`/v1/leads/${leadId}/activities/`);
    return response.data;
  },

  // Create lead activity
  createLeadActivity: async (leadId, activityData) => {
    const response = await api.post(`/v1/leads/${leadId}/activities/`, activityData);
    return response.data;
  },

  // Get lead stats
  getLeadStats: async () => {
    const response = await api.get('/v1/leads/stats/');
    return response.data;
  },

  // Bulk update leads
  bulkUpdateLeads: async (leadIds, updateData) => {
    const response = await api.patch('/v1/leads/bulk_update/', {
      lead_ids: leadIds,
      update_data: updateData,
    });
    return response.data;
  },
};